enum CreativeFilePlacementType {
  InStream = 'IN_STREAM',
  InBanner = 'IN_BANNER',
  InArticle = 'IN_ARTICLE',
  InFeed = 'IN_FEED',
  Interstitial = 'INTERSTITIAL',
}

export default CreativeFilePlacementType;
